import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AutoITRDetails } from 'app/shared/models/global/auto-itr-details';
import { AutoITRService } from 'app/shared/services/global/auto.itr.service';
import { MessageService } from 'app/shared/services/global/message.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-autoitr',
  templateUrl: './autoitr.component.html',
})
export class AutoitrComponent implements OnInit {
  modalRef: BsModalRef;
  autoITRDetails: AutoITRDetails = new AutoITRDetails();
  personId: number;
  financialId: number;
  uuid: String;
  setTabIndex = 0;
  isHufOrFirm = false;

  @Output() autoItr: EventEmitter<any> = new EventEmitter();

  constructor(public activatedRoute: ActivatedRoute, public modalService: BsModalService, public autoItrService: AutoITRService, public message: MessageService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.personId = +params['p_id'];
      this.financialId = +params['f_id'];
      this.uuid = params['comp'];
    });

    this.isHufOrFirm = (this.autoItrService.partyType === 2 || this.autoItrService.partyType === 3);

    if (this.personId && this.financialId) {
      this.autoItrService.getAutoItrDetailsByPidFid().then(res => {
        this.autoITRDetails = res['data'];
        this.autoITRDetails.person_id = this.personId;
        this.autoITRDetails.financial_id = this.financialId;
      });
    } else if (this.uuid) {
      this.autoItrService.getAutoItrDetailsByUUID(this.uuid).then(res => {
        this.autoITRDetails = res['data'];
        this.autoITRDetails.uuid = this.uuid;
      });
    }
  }

  ngOnInit() { }

  closeAutoITR() {
    if (this.autoItrService.getModalLocation === 'login') {
      this.autoItr.emit(null);
    }
    this.modalService.hide(1);
  }

  submitAutoITR() {
    if (this.validationA() && this.validationB()) {
      console.log('submit called..' + this.autoItrService.getModalLocation);
      this.autoITRDetails.partyType = this.autoItrService.partyTypeId;
      if (this.autoItrService.getModalLocation === 'header') {
        this.autoItrService.saveAndChangeItr(this.autoITRDetails).then(res => {
          this.closeAutoITR();
        });
      } else if (this.autoItrService.getModalLocation === 'login') {
        this.autoItrService.saveAutoItr(this.autoITRDetails).then(res => {
          this.autoItr.emit(res['data']);
          this.closeAutoITR();
        });
      }
    }
  }

  toggleCheck(event, field) {
    if (event.source.name === 'yes' && event.checked) {
      this.autoITRDetails[field] = true;
    } else if (event.source.name === 'no' && event.checked) {
      this.autoITRDetails[field] = false;
    } else {
      this.autoITRDetails[field] = null;
    }
  }

  validationA() {
    if (this.autoITRDetails.isResidentialStatusInIndia === null || this.autoITRDetails.isResidentialStatusInIndia === undefined
      || this.autoITRDetails.isDirectorInompany === null || this.autoITRDetails.isDirectorInompany === undefined
      || this.autoITRDetails.hasHeldAnyUnlistedEquitySharesDuringPreviousYear === null || this.autoITRDetails.hasHeldAnyUnlistedEquitySharesDuringPreviousYear === undefined
      || this.autoITRDetails.hasAnyAssetOrSigningAuthorityOrIncomeFromOutsideIndia === null || this.autoITRDetails.hasAnyAssetOrSigningAuthorityOrIncomeFromOutsideIndia === undefined) {
        this.message.displayErrorToaster('Each Item of Part A is compalsary to be ticked for "YES" or "NO"!');
        return false;
    }
    return true;
  }

  validationB() {
    if (this.autoITRDetails.incomeFromSalaryOrPension || this.autoITRDetails.incomeOnlyfromOneHouseproperty
      || this.autoITRDetails.incomeTaxableOsOnlyFromInterestOrFamilyPension || this.autoITRDetails.incomeFromBusinessOrProfessionComputedOn44AD_44ADA_44AE
      || this.autoITRDetails.capitalGains || this.autoITRDetails.profitsAndGainsFromBpSbAbCommissionBrokerage
      || this.autoITRDetails.isIncomeWithProvisionsOfSection5A || this.autoITRDetails.isAgriculturalIncomeInExcess || this.autoITRDetails.hasAnyClaimsOfLossDeductionsReliefTaxCredit) {
      return true;
    }
    this.message.displayErrorToaster('Atleact one of the Item of Part B is mandatory to be ticked for "YES"!');
    return false;
  }

  tab(event) {
    const indexName = (event.index === 0) ? 'A' : 'B';
    this.tabchange(indexName);
  }

  tabchange(btn) {
    if (btn === 'next' || btn === 'B') {
      if (this.validationA()) {
        this.setTabIndex = 1;
      } else {
        this.setTabIndex = 0;
      }
    } else if (btn === 'prev' || btn === 'A') {
      this.setTabIndex = 0;
    }
  }
}
